export const locale = {
    lang: 'pt',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': 'Pesquisa piloto:',
        'ENCUESTA_PILOTO_ENVIO': 'Envio da pesquisa piloto',
        'ENCUESTA_LANZAMIENTO':'Confirmação de lançamento',
        'BTN_COPY':'Copiar chave de pesquisa ',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'Criar pesquisa',
        'ENCUESTA_DEMO':'Pesquisa piloto',
        'BOTON_CREAR_ENCUESTA':'Gerar pesquisa',
        'STEP': 'Etapa completa',
        'SEE_TI': 'Ver requisitos técnicos',
        'CLAVE': 'Chave de acesso:',
        'ACCESO': 'ACESSO',
        'NOFECHA':'Você não pode fazer esta ação porque não há uma data de lançamento',
        'LABEL01': 'Copie e cole a senha na pesquisa piloto',
        'LABEL02': 'O envio da pesquisa foi confirmado',
        'LABEL03':'Correio eletrônico',
        'LABEL04': 'Enviando a pesquisa piloto',
        'LABEL05': 'A ação não pôde ser executada',
        'LABEL06': 'A pesquisa piloto foi enviada com sucesso',
        'LABEL07': 'Campo obrigatório',
        'LABEL08': 'Etapa completa',
        'LABEL09': 'Usuários de demonstração de pesquisa estão exaustos',
        'CONFIRMAR_ENVIO': 'Confirmar o envio de emails',
        'DES_CONFIRMAR_ENVIO': 'Desconfirmar o envio de e-mails',
        'SI_CONFIRMAR_ENVIO': 'sim',
        'NO_CONFIRMAR_ENVIO': 'Não',
        'CHANGE-OPTIONS':'Alterar opções de correio',
        'NO_ENVIO_CORREO':'Nenhum correio será enviado',
        'SI_ENVIO_CORREO':'Os e-mails serão enviados',
        'EN_CASO':'Ao selecionar NÃO, toda a comunicação sobre a pesquisa deve ser tratada fora da plataforma. Nenhum e-mail será enviado aos usuários.',
        'CONFIRMAR_ENVIO_35': 'Confirme o envio da pesquisa',
        'AUTOLOG_35': 'Link para login automático da pesquisa:',
        'TITULO':'Nesta seção, você pode realizar um teste de visualização de pesquisa:',
        'LINK':'1. Acesse o seguinte link:',
        'LINKNORMA35':'1. Acesse o seguinte link para a pesquisa de',
        'CLAVE_ENCUESTA':'2. Copie esta chave de teste:',
        'INSTRUCCION3':'3. Cole a chave na célula de senha',
        'INSTRUCCION4':'4. Clique em Login',
        'TEXTO_CONFIRMAR':'Confirme que a comunicação com os usuários (convite e lembretes) será feita por e-mail',
        'TEXTO_CONFIRMAR2':'EM CASO DE VOCÊ NÃO QUER QUE OS CORREIOS SÃO ENVIADOS, basta saltar o clique e fechar o passo.',
        'TITULO_PILOTO':'Nesta seção, você pode enviar o email de convite para participar, até cinco colaboradores diferentes, de um teste de recebimento do email e visualização da pesquisa, antes do lançamento real da pesquisa.:',
        'INSTRUCCION_PILOTO':'1. Insira os e-mails e selecione o idioma no qual deseja receber o convite',
        'INSTRUCCION_PILOTO2':'2. Clique no botão "Enviar a pesquisa piloto"',
        'SELLANG': 'Selecione um idioma',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> Para confirmar que nenhum convite ou lembrete por e-mail será enviado, digite o código em vermelho na caixa de texto ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'A configuração foi modificada',

        'BTN_MODALES':{
          'CONFIRMAR':'confirme',
          'SALIR':'Saída',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
          'MAS50':'más 50',
          'MENOS50':'menos 50',
          'CORTA': 'Aceeso general',
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1. Acesse o seguinte link:',
          'CLAVE_ENCUESTA':'2. Copie uma das chaves geradas na seção "usuários de demonstração"',
          'INSTRUCCION3':'3. Cole a chave na célula de senha',
          'INSTRUCCION4':'4. Clique em Login',
          'USERSDEMO':'Usuários de demonstração',
          'USERS':'Do utilizador',
          'CLAVE':'Chave',
          'ESTATUS':'Estado',
          'ESTATUS-USER-ASIGNA':'Atribuído',
          'INST_UPD_URL_NAME':'Personalize a ShortUrl digitando até 6 caracteres de texto que seja familiar aos seus usuários.',
          'BTN_UPD_GUARDA':'Salve',
          'BTN_UPD_CAN':'Cancelar',
          'CUS_SHOI_URL':'Personalize o URL da pesquisa',
          'MODAL_ACTU_CUS_SHOI_URL':'Atualizando o nome no url',
          'ACTU_CUS_SHOI_URL_OK':'O nome no url foi atualizado corretamente',
          'ACTU_CUS_SHOI_URL_FALSE':'O nome na url já existe',
        },


        'ALERT':{
            'HEADER':'Info',
            'MESSAGE_CON': '¿Você deseja confirmar o envio de e-mails aos usuários?',
            'MESSAGE': '¿Deseja confirmar o envio de e-mails aos seus colaboradores?',
            'MESSAGE_DESCON': '¿Você tem certeza de não confirmar o envio de e-mails aos usuários?',
            'BTN_CANCEL': 'Sem cancelamento',
            'BTN_CONFIRM': 'OK envie',
            'BTN_NO_CONFIRM': 'Não manda',
            'BTN_SI_CONFIRM': 'Sim manda',
            'BTN_NO_CANCEL': 'Cancelar',
            'BTN_OK': 'Ok',
            'ERROR_01':'Você ainda não enviou nenhum convite',
            'SINCOLABS': 'Você não pode enviar o convite para a pesquisa ainda, você deve fazer o upload da lista de participantes da empresa antes',
            'SINLANG': 'Você ainda não selecionou um idioma para um ou mais endereços de e-mail inseridos',
            'ERRMAIL': 'O e-mail digitado não tem a sintaxe correta, verifique-o e digite-o novamente'
        }
      },
      'PULSE':{
          'LABEL01': 'Envie a pesquisa para seus colaboradores',
      }
    }
};
